import { createStore, applyMiddleware, compose } from 'redux';
import createHistory from 'history/createBrowserHistory';
import { routerReducer, routerMiddleware, LOCATION_CHANGE } from 'react-router-redux';
import thunk from 'redux-thunk';
import createSagaMiddleware from 'redux-saga';
import reducers from '../redux/reducers';
import rootSaga from '../redux/sagas';
import { fromJS } from 'immutable';
import { autoRehydrate } from 'redux-persist-immutable'
const sagaMiddleware = createSagaMiddleware();
import { combineReducers } from 'redux-immutable';

const routeInitialState = fromJS({
  location: null,
});
function routeReducer(state = routeInitialState, action) {
  switch (action.type) {
    /* istanbul ignore next */
    case LOCATION_CHANGE:
      return state.merge({
        location: action.payload,
      });
    default:
      return state;
  }
}


export default function configureStore(initialState = {}, history) {
  // const history = createHistory();
  const routeMiddleware = routerMiddleware(history);

  const middlewares = [
    // thunk, 
    sagaMiddleware, 
    routeMiddleware
  ];

  const enhancers = [
    applyMiddleware(...middlewares),
    autoRehydrate()
  ];

  const composeEnhancers =
    process.env.NODE_ENV !== 'production' &&
    typeof window === 'object' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        shouldHotReload: false,
      })
      : compose;

  const rootReducer =  combineReducers({
    ...reducers,
    router: routerReducer
  });
  console.log( rootReducer)

  
  const store = createStore(
    rootReducer,
    fromJS(initialState),
    composeEnhancers(...enhancers)
  );
  sagaMiddleware.run(rootSaga);

  return store
}
// export default { store, history };



// WEBPACK FOOTER //
// ./src/redux/store.js